/**
 * Template - Data mapper for RFI2 - Trim
 * Section UID (in template) : Section Path in data
 */
export const rfi2TrimSectionMapper = {
  //Business Capabilities
  total_trim_capabilities:
    'dynamic_sections.business_capability.total_trim_capabilities',
  service_capabilities:
    'dynamic_sections.business_capability.service_capabilities',
  certifications: 'dynamic_sections.business_capability.certifications',
  capacity_machinery: 'dynamic_sections.business_capability.capacity_machinery',
  quality_control: 'dynamic_sections.business_capability.quality_control',

  //Supply Chain
  production_outsourcing:
    'dynamic_sections.supply_chain.production_outsourcing',
  service_outsourcing: 'dynamic_sections.supply_chain.service_outsourcing',

  //Responsible Sourcing
  responsible_sourcing_sustainability_for_trim:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability_for_trim',

  //Other Information
  ownership_information:
    'dynamic_sections.other_information.ownership_information',
  research_and_development:
    'dynamic_sections.other_information.research_and_development',
  factory_automation_level:
    'dynamic_sections.other_information.factory_automation_level',
  employee_information:
    'dynamic_sections.other_information.employee_information',
  //country specific validation
  additional_factory_information:
    'dynamic_sections.other_information.additional_factory_information',
}
